import type { UnknownQueryParam, PageRouteDefinition, ParsedQueryParams } from "@octopusdeploy/portal-routes";
import type { ReactElement } from "react";
import type { PageRegistration } from "~/routing/pageRegistrations/PageRegistration";
import type { PageIdentity } from "./PageIdentity";
export interface TenantPageRegistration<RouteParams, QueryParams extends UnknownQueryParam[]> extends PageRegistration<RouteParams, QueryParams> {
    render: (parameters: RouteParams, queryParams: ParsedQueryParams<QueryParams>, setQueryParams: (queryParams: ParsedQueryParams<QueryParams>) => void) => ReactElement;
}
export function createTenantPageRegistration<RouteParams, QueryParams extends UnknownQueryParam[]>(route: PageRouteDefinition<RouteParams, QueryParams>, render: (parameters: RouteParams, queryParams: ParsedQueryParams<QueryParams>, setQueryParams: (queryParams: ParsedQueryParams<QueryParams>) => void) => ReactElement, pageIdentity: PageIdentity, legacyRouteLink: (parameters: RouteParams, queryParams: ParsedQueryParams<QueryParams>) => string): TenantPageRegistration<RouteParams, QueryParams> {
    return {
        route,
        render,
        legacyRouteLink,
        pageIdentity,
    };
}
